<!-- 车辆通行授权页面 -->
<template>
  <div class="carInfo-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- tab栏 -->
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <ioc-tab-group
          ref="tabs"
          :class="personType.prop"
          :option="tabOption"
          @change="handleChange"
        ></ioc-tab-group>
        <div
          class="flex-row flex-auto tree-line-style"
          style="overflow: hidden"
        >
          <!-- 左侧树 -->
          <div class="section-mian_left" v-show="personType.prop === 'visitor'">
            <div class="left_title">已有类型信息</div>
            <el-scrollbar class="flex-auto">
              <el-tree
                ref="tree"
                class="tree-content"
                :data="vehicleTypeList"
                :expand-on-click-node="false"
                node-key="visitorVehicleTypeCode"
                :props="defaultProps"
                :highlight-current="true"
                :default-expand-all="true"
                :default-checked-keys="menuCheckedKeys"
                @node-click="handleNodeClick"
              >
                <template slot-scope="{ node, data }">
                  <element-tree-line
                    :node="node"
                    :showLabelLine="true"
                    :indent="16"
                    class="tree-line"
                  >
                    <span class="custom-tree-node">
                      <span :title="node.label" class="view-label">{{
                        node.label
                      }}</span>
                      <div class="area-operator">
                        <el-button
                          v-if="data.isParent"
                          type="text"
                          size="medium"
                          @click.stop="addType"
                          class="el-icon-circle-plus-outline"
                          title="新增"
                        ></el-button>
                        <el-button
                          v-if="
                            !data.isParent &&
                            checkNodeRight.visitorVehicleTypeCode ==
                              data.visitorVehicleTypeCode
                          "
                          type="text"
                          size="medium"
                          class="el-icon-edit-outline"
                          title="修改"
                          @click.stop="() => handleEditType(node, data)"
                        ></el-button>
                        <el-button
                          v-if="
                            !data.isParent &&
                            checkNodeRight.visitorVehicleTypeCode ==
                              data.visitorVehicleTypeCode
                          "
                          type="text"
                          size="medium"
                          class="el-icon-delete-solid"
                          title="删除"
                          @click.stop="() => deleteClick(node, data)"
                        ></el-button>
                      </div>
                    </span>
                  </element-tree-line>
                </template>
              </el-tree>
            </el-scrollbar>
          </div>
          <!-- 右侧表格 -->
          <div class="flex-auto flex-valign" style="overflow: hidden">
            <ioc-table
              ref="carTab"
              :data="tableData"
              :option="tableOption"
              :page="page"
              @row-save="handleAuthority"
              @row-cancle="closeDialog"
              @search-change="searchResult"
              @search-reset="resetQuery"
              @current-change="selectPage"
              @selection-change="selectionChange"
              @size-change="changeSize"
              @close-callback="dialogClose"
            >
              <template slot="menuLeft">
                <el-button
                  type="primary"
                  size="small"
                  class="iss-operation-button"
                  icon="el-icon-plus"
                  v-auth="'/carInfo/index:add'"
                  @click="handleAddCar"
                >
                  新增
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  class="iss-operation-button"
                  icon="el-icon-delete"
                  v-auth="'/carInfo/index:delete'"
                  @click="deleteCar()"
                >
                  删除
                </el-button>
                <el-button
                  type="primary"
                  class="iss-operation-button"
                  icon="iconfont icon-jinru"
                  v-auth="'/carInfo/index:update'"
                  v-if="personnelType == 2"
                  @click="moveIn"
                  >{{ $t("cameraList.button.moveInto") }}</el-button
                >
                <el-button
                  type="primary"
                  class="iss-operation-button"
                  icon="iconfont icon-likai"
                  v-auth="'/carInfo/index:update'"
                  v-if="personnelType == 2"
                  @click="moveOut"
                  >{{ $t("cameraList.button.moveOut") }}</el-button
                >
                <el-upload
                  ref="upload"
                  class="upload-demo"
                  multiple
                  :limit="1"
                  :auto-upload="false"
                  :on-change="batchImport"
                  action
                  :show-file-list="false"
                >
                  <el-button
                    type="primary"
                    v-auth="'/carInfo/index:import'"
                    class="iss-operation-button-upload"
                    icon="iconfont icon-daoru"
                    >批量导入</el-button
                  >
                </el-upload>
                <el-button
                  type="primary"
                  class="iss-operation-button-download"
                  icon="el-icon-download"
                  @click="downTemplate"
                  >模板下载</el-button
                >
              </template>
              <template slot="nameForm">
                <el-input
                  v-model="customForm.name"
                  @focus="openChoose"
                  readonly
                  placeholder="请选择车主"
                  class="person-shoose"
                ></el-input>
              </template>
              <template slot="visitorVehicleTypeNameForm">
                <el-select v-model="customForm.vehicleType">
                  <el-option
                    v-for="(item, index) in visitorVehicleTypeList"
                    :label="item.visitorVehicleTypeName"
                    :value="item.visitorVehicleTypeCode"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </template>
              <!-- 车牌点击跳转详情页面 -->
              <template slot="plateCode" slot-scope="scope">
                <el-button
                  type="text"
                  @click="handleView(scope.row, scope.index)"
                  >{{ scope.row.plateCode }}</el-button
                >
              </template>

              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  class="item m5"
                  effect="dark"
                  content="删除"
                  placement="top-start"
                >
                  <el-button
                    type="text"
                    icon="iconfont icon-shanchu"
                    @click="handleDel(scope.row, scope.index)"
                  ></el-button>
                </el-tooltip>
                <!-- <el-tooltip
                  class="item m5"
                  effect="dark"
                  content="查询轨迹"
                  placement="top-start"
                >
                  <el-button
                    type="text"
                    title="查询轨迹"
                    style="font-size: 16px"
                    class="iconfont-lunan icon-blue el-icon-location"
                    @click="retBtn(scope.row)"
                  ></el-button>
                </el-tooltip> -->
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 人员选择弹框 -->
    <el-dialog
      :title="personnelType == 1 ? '人员选择' : '访客选择'"
      :visible.sync="linkDialog"
      width="800px"
      v-dialogDrag
      class="choose-container"
      height="654px"
    >
      <ioc-table
        ref="crud"
        :data="personData"
        :option="personOption"
        :page="personPage"
        @size-change="personChangeSize"
        @current-change="currentChange"
        @search-change="searchList"
        @search-reset="personReset"
      >
        <template slot="personnelCode" slot-scope="scope">
          <el-radio
            :label="scope.row.personnelCode"
            v-model="personnelCode"
            @change="radioChange(scope.row)"
            >{{ "" }}</el-radio
          >
        </template>
      </ioc-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelChoose">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗 -->
    <el-dialog
      :title="state === 1 ? '新增车辆类型' : '修改车辆类型'"
      v-ops:width="480"
      :visible.sync="formShow"
      @close="formClose"
      :close-on-click-modal="false"
    >
      <ioc-forms
        :option="formOption"
        :formData="formData"
        ref="form"
      ></ioc-forms>
      <!-- <ioc-form :option="formOption" v-model="formData" ref="form"></ioc-form> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="formClose"> 取 消 </el-button>
        <el-button type="primary" @click="saveVehicleType" v-status>
          保 存
        </el-button>
      </span>
    </el-dialog>
    <!--选择类型树-->
    <el-dialog
      v-ops:width="380"
      width="30%"
      v-dialogDrag
      title="选择挪入访客车辆类型"
      :visible.sync="typeTreeShow"
      center
    >
      <el-tree
        :data="typeData"
        :highlight-current="true"
        :props="defaultProps"
        @node-click="selectAreaNode"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moveVisitorVehicleType(1)">{{
          $t("cameraList.button.conform")
        }}</el-button>
        <el-button @click="typeTreeShow = false">{{
          $t("cameraList.button.cancel")
        }}</el-button>
      </span>
    </el-dialog>
    <dialog-map ref="dialogMap"></dialog-map>
  </div>
</template>
<script>
import ElementTreeLine from "element-tree-line";
import { api } from "../api/index";
import utils from "@src/common/utils";
import { Dic, Bus, Dates } from "$utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../config/table";
import personOption from "../config/personOptions";
import visitorVehicleTypeOption from "../config/visitorVehicleType";
import dialogMap from "@src/components/common/app-dialog/dialog-map";
const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};
export default {
  components: {
    dialogMap,
    ElementTreeLine,
  },
  data() {
    return {
      menuCheckedKeys: [],
      checkNodeRight: {},
      tabOption: {
        column: [
          {
            label: "员工车辆",
            prop: "staff",
            typeId: "1",
          },
          {
            label: "访客车辆",
            prop: "visitor",
            typeId: "2",
          },
        ],
      },
      visitorVehicleTypeList: [],
      tableOption: tableOption(true, true),
      personOption: personOption(false),
      // 分页属性设置
      page: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      customForm: {
        name: "",
      },
      personType: {},
      tableData: [],
      searchParams: {},
      // 选择的车辆Id
      checkedIds: [],
      linkDialog: false,
      personData: [],
      personPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      personSearch: {},
      // 人员Id
      personnelCode: "",
      currenPersonInfo: {},
      downFileName: "importVehicleTemplate",
      vehicleTypeList: [
        {
          children: [],
          isParent: true,
          visitorVehicleTypeName: "访客车辆类型",
          type: 1,
          visitorVehicleTypeCode: "-1",
        },
      ],
      BrandType: Dic.find("SENU042"),
      personnelType: 1,
      activeStyle: "",
      visitorVehicleTypeCode: "",
      formShow: false,
      formOption: visitorVehicleTypeOption(),
      formData: {
        name: "",
        type: "",
      },
      state: 1, // 1: 新增 2：修改
      defaultProps: {
        children: "children",
        label: "visitorVehicleTypeName",
      },
      typeData: [
        {
          visitorVehicleTypeName: "访客车辆类型",
          visitorVehicleTypeCode: "-1",
          children: [],
        },
      ],
      typeTreeShow: false,
    };
  },
  watch: {
    customForm: {
      handler(newValue) {
        this.$refs.carTab.setForm("name", newValue.name);
        this.$refs.carTab.setForm("phone", newValue.phone);
      },
      deep: true,
    },
  },
  created() {
    // 默认进入页面选中第一种分类方式
    this.personType = this.tabOption.column[0];
  },
  mounted() {
    if (this.personnelType == 1) {
      this.getList(1);
    }
    this.queryVisitorVehicleType();
  },
  methods: {
    handleNodeClick(data) {
      this.personPage.currentPage = 1;
      this.personPage.pageSize = 10;
      this.checkNodeRight = data;
      if (data.isParent) {
        this.visitorVehicleTypeCode = "";
      } else {
        this.visitorVehicleTypeCode = data.visitorVehicleTypeCode;
      }
      this.getList(2);
    },
    retBtn(row) {
      this.$refs.dialogMap.openMap(row, 1);
    },
    // 获取模板下载
    downTemplate() {
      this.$fetchGet(api.vehicle.download, {
        responseType: "blob", //设置返回类型
      }).then((res) => {
        if (typeof window.chrome !== "undefined") {
          // Chrome version
          const blob = new Blob([res], { type: "application/vnd.ms-excel" });
          const url = window.URL || window.webkitURL || window.moxURL;
          const urls = url.createObjectURL(blob);
          const a = document.createElement("a"); // 生成虚拟a标签
          a.href = urls;
          a.download = this.downFileName + ".xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          url.revokeObjectURL(urls); // 释放掉blob对象
        } else if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE version
          const blob = new Blob([res], { type: "application/force-download" });
          window.navigator.msSaveBlob(blob, this.downFileName + ".xlsx");
        } else {
          // Firefox version
          const file = new File([res], this.downFileName + ".xlsx", {
            type: "application/force-download",
          });
          window.open(URL.createObjectURL(file));
        }
      });
    },
    // 切换选项卡
    handleChange(column) {
      // console.log('column', column)
      this.visitorVehicleTypeCode = "";
      this.personType = column;
      if (this.personType.typeId === "1") {
        this.tableOption = tableOption(true, true);
        this.personOption = personOption(false);
        this.personnelType = 1;
        // this.getList(1);
      } else {
        this.tableOption = tableOption(false, true);
        this.personOption = personOption(true);
        this.personnelType = 2;
        // this.getList(2);
      }
      this.$nextTick(() => {
        this.$refs.carTab.reset();
      });
      // console.log('personnelType', this.personnelType)
    },
    // 获取访客车辆类型组接口
    queryVisitorVehicleType() {
      this.$fetch(api.vehicle.queryVisitorVehicleType, {}).then((res) => {
        if (res.success) {
          this.vehicleTypeList[0].children = res.returnObj;
          this.typeData[0].children = res.returnObj;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.vehicleTypeList[0]);
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    addType(type) {
      this.state = 1;
      this.formShow = true;
      // this.$refs["form"].clearValidate();
    },
    // 获取车辆列表
    getList(personType) {
      const params = {};
      params.vehicleColor = this.searchParams.vehicleColor;
      params.vehicleType = this.searchParams.vehicleType;
      params.plateCode = this.searchParams.plateCode;
      params.name = this.searchParams.name;
      params.personnelType = personType;
      params.pageNum = this.page.pageNum;
      params.pageSize = this.page.pageSize;
      params.visitorVehicleTypeCode = this.visitorVehicleTypeCode;
      // const loading = this.$loading({
      //   lock: true,
      //   text: "请求中",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      this.$fetch(api.vehicle.getVehicleList, params).then((response) => {
        // setTimeout(() => {
        //   loading.close();
        // }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.carTab.selectClear();
      });
    },
    // 获取人员选择弹框中人员列表
    getPersonList() {
      const params = {};
      params.personnelType = this.personnelType;
      params.workNo = this.personSearch.workNo;
      params.name = this.personSearch.name;
      params.pageNum = this.personPage.pageNum;
      params.pageSize = this.personPage.pageSize;
      this.$fetch(api.person.getPersonList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.personData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.personPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },
    // 新增按钮
    handleAddCar() {
      this.customForm.name = "";
      this.customForm.phone = "";
      this.$refs.carTab.rowAdd();
      this.$fetch("/vas/vehicle/queryVisitorVehicleTypeList.json", {}).then(
        (res) => {
          if (res.success) {
            this.visitorVehicleTypeList = res.returnObj;
          }
        }
      );
    },
    openChoose() {
      this.linkDialog = true;
      this.getPersonList();
    },
    radioChange(val) {
      console.log(val);
      if (val) {
        this.currenPersonInfo = val;
        // this.personnelCode = val.personnelCode;
        // this.customForm.name = val.name;
        // this.customForm.phone = val.phone;
      }
    },
    // 新增弹框
    handleAuthority(addInfo, done) {
      console.log(addInfo, "addInfo", this.personnelType);
      let params = {
        personnelCode: this.personnelCode,
        plateCode: addInfo.plateCode,
        plateColor: addInfo.plateColor,
        plateType: addInfo.plateType,
        vehicleColor: addInfo.vehicleColor, // "1",
        vehicleType: addInfo.vehicleType,
        visitorVehicleTypeCode: this.visitorVehicleTypeCode,
        operateType: this.personnelType,
        // modifyTime: addInfo.modifyTime,
        phone: addInfo.phone,
        desc: addInfo.desc,
      };
      this.$fetch(api.vehicle.addVehicle, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          this.$message.success(response.msgContent || "新增车辆成功");
          this.getList(this.personnelType);
        }
        done();
      });
    },
    // 人员选择确认弹框
    confirmChoose() {
      if (!this.personnelCode) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择人员",
        });
        return;
      }
      this.customForm.name = this.currenPersonInfo.name;
      this.customForm.phone = this.currenPersonInfo.phone;
      this.personnelCode = this.currenPersonInfo.personnelCode;

      this.linkDialog = false;
    },
    // 人员选择取消弹框
    cancelChoose() {
      // this.customForm.name = "";
      // this.customForm.phone = "";
      // this.personnelCode = "";
      this.currenPersonInfo = null;
      this.linkDialog = false;
    },
    handleDel(info) {
      this.deleteCar(info.vehicleCode);
    },
    // 删除按钮
    deleteCar(id) {
      console.log(id);
      let params = {
        vehicleCodeList: (id && [id]) || this.checkedIds,
      };
      if (params.vehicleCodeList.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择你要删除的车辆",
        });
        return;
      }

      this.$confirm("您确定删除选择的车辆名单吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.vehicle.deleteVechicle, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent || "删除失败");
            return;
          } else {
            this.$message.success(response.msgContent);
            this.getList(this.personnelType);
          }
        });
      });
    },
    // 批量导入按钮
    batchImport(file) {
      if (
        file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        ) !== "xlsx" &&
        file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        ) !== "xls"
      ) {
        this.$message({
          message: "文件格式不正确",
          type: "warning",
        });
      } else {
        let formData = new FormData();
        formData.append("file", file.raw);
        formData.append("operateType", this.personnelType);
        // 调用导入接口
        this.$fetch(api.vehicle.importVehicle, formData).then((response) => {
          if (response.success) {
            this.$message({
              message: "导入文件成功",
              type: "success",
            });
            this.getList(this.personnelType);
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
            });
          }
          this.$refs.upload.clearFiles();
        });
      }
    },
    closeDialog() {},
    dialogClose() {
      this.customForm.name = "";
      this.customForm.phone = "";
    },

    // 查询按钮事件
    searchResult(param) {
      if (this.personType.prop === "staff") {
        this.searchParams = Object.assign(param);
        this.page.pageNum = 1;
        this.getList(1);
      } else {
        this.searchParams = Object.assign(param);
        this.page.pageNum = 1;
        this.getList(2);
      }
    },
    // 重置按钮
    resetQuery() {
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },

    // 当选择项发生变化时会触发该事件
    selectionChange(items) {
      this.checkedIds = items.map((item) => {
        return item.vehicleCode;
      });
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.pageNum = val;
      //调用列表接口
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      //调用列表接口
      if (this.personType.prop === "staff") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },
    // 员工弹框修改每页数据数量
    personChangeSize(val) {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = val;
      this.getPersonList();
    },
    currentChange(val) {
      this.personPage.pageNum = val;
      this.getPersonList();
    },
    searchList(param) {
      this.personSearch = Object.assign(param);
      this.personPage.pageNum = 1;
      this.getPersonList();
    },
    personReset() {
      this.getPersonList();
    },
    // 删除
    deleteClick(item, info) {
      this.$confirm("您确定删除该访客车辆类型么?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          visitorVehicleTypeCode: info.visitorVehicleTypeCode,
        };
        // this.getList(2, info.visitorVehicleTypeCode);
        // setTimeout(() => {
        this.$fetch(api.vehicle.deleteVisitorVehicleType, params).then(
          (response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
              return;
            } else {
              this.visitorVehicleTypeCode = "";
              this.$message.success("删除成功");
              this.getList(2);
              this.queryVisitorVehicleType();
            }
          }
        );
        // }, 500);
      });
    },
    // 修改
    handleEditType(item, info) {
      // this.getList(2, item.visitorVehicleTypeCode);
      this.formShow = true;
      this.state = 2;
      this.formData.name = info.visitorVehicleTypeName;
      this.visitorVehicleTypeCode = info.visitorVehicleTypeCode;
    },
    // 新增修改弹窗 关闭清除数据
    formClose() {
      this.formShow = false;
      this.$refs["form"].$refs["form"].resetFields();
    },
    // 新增/修改保存访客车辆类型
    saveVehicleType() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url =
            this.state === 1
              ? api.vehicle.addVisitorVehicleType
              : api.vehicle.updateVisitorVehicleType;
          let params = {};
          if (this.state === 1) {
            params = {
              visitorVehicleTypeName: trim(this.formData.name),
            };
          } else {
            params = {
              visitorVehicleTypeName: trim(this.formData.name),
              visitorVehicleTypeCode: this.visitorVehicleTypeCode,
            };
          }
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message({
                message: this.state === 1 ? "新增成功" : "修改成功",
                type: "success",
                duration: 2000,
              });
              this.formShow = false;
              this.queryVisitorVehicleType();
              if (this.state === 1) {
                this.activeStyle = this.vehicleTypeList[0].name;
              } else {
                this.activeStyle = trim(this.formData.name);
              }
              // this.getList(2, this.visitorVehicleTypeCode);
              // this.queryVisitorVehicleType();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    moveVisitorVehicleType(operateType) {
      const params = {
        vehicleCodeList: this.checkedIds,
        operateType: operateType,
        visitorVehicleTypeCode: this.selectedAreaNode,
      };
      this.$fetch(api.vehicle.updateVehicleVisitorVehicleType, params).then(
        (res) => {
          if (res.success) {
            this.$message.success(operateType == "1" ? "挪入成功" : "挪出成功");
            this.typeTreeShow = false;
            this.getList(2, this.selectedAreaNode);
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },
    selectAreaNode(data) {
      this.selectedAreaNode = data.visitorVehicleTypeCode;
      console.log("dddddddddddddddddddd___________", this.selectedAreaNode);
    },
    //挪入
    moveIn() {
      if (!this.checkedIds.length) {
        this.$message({
          message: "请选择挪入访客车辆",
          type: "warning",
        });
        return;
      }
      this.slectedAreaNode = "";
      this.typeTreeShow = true;
    },
    //挪出
    moveOut() {
      if (!this.checkedIds.length) {
        this.$message({
          message: "请选择挪出访客车辆",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否要挪出车辆", "确认", {
        confirmButtonText: this.$t("cameraList.button.conform"),
        cancelButtonText: this.$t("cameraList.button.cancel"),
        type: "warning",
      }).then(() => {
        this.selectedAreaNode = this.visitorVehicleTypeCode;
        this.moveVisitorVehicleType("2");
      });
    },
    handleView(row, index) {
      this.$refs.carTab.rowView(row, index);
    },
  },
};
</script>
<style lang="scss">
.carInfo-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .ioc-tab-group{
    margin-bottom: 12px;
    background: #fff;
  }
  .el-tabs__nav {
    width: 100% !important;
    display: flex;
    justify-content: space-around;
  }

  .el-tabs__active-bar {
    width: 50% !important;
  }
  .el-table__fixed-right-patch {
    display: none;
  }
  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 250px;
    }
  }
  .upload-demo {
    margin-left: 10px;
    display: inline-block;
  }
  .iss-operation-button-download {
    margin-left: 10px;
  }
  .section-mian_left {
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    // flex: 1;
    // overflow-y: auto;
    // cursor: pointer;
    .show {
      width: 220px;
    }
    .list-item {
      .title {
        line-height: 35px;
        display: flex;
        flex-direction: row;
        align-items: center;
        &:hover,
        &.active {
          background-color: #3f619b;
        }
        i {
          color: #939cad;
        }
        .el-icon-plus {
          cursor: pointer;
        }
        .changeStyle {
          position: absolute;
          right: 10px;
        }
      }
      .list-text {
        padding-left: 20px;
        line-height: 35px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: flex;
        align-items: center;
        &:hover,
        &.active {
          background-color: #3f619b;
        }

        .list-name {
          width: 140px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .visitor {
    .el-tabs__active-bar {
      width: 50% !important;
      transform: translateX(100%) !important;
    }
  }
}
.choose-container {
  .el-dialog__body {
    .ioc-table {
      height: 400px;
    }
  }
}
.el-dialog__body {
  .el-form {
    // .el-col-12 {
    //   &:nth-child(2) {
    //     .el-form-item__label {
    //       &:before {
    //         content: '*';
    //         color: #f56c6c;
    //         margin-right: 4px;
    //       }
    //     }
    //   }
    // }
    .person-shoose {
      .el-input__inner::placeholder {
        color: #00e8bb;
        text-align: right;
      }
      /* 谷歌 */
      .el-input__inner::-webkit-input-placeholder {
        color: #00e8bb;
        text-align: right;
      }
      /* 火狐 */
      .el-input__inner:-moz-placeholder {
        color: #00e8bb;
        text-align: right;
      }
      /*ie*/
      .el-input__inner:-ms-input-placeholder {
        color: #00e8bb;
        text-align: right;
      }
    }
  }
}

.left_title {
  border-left: 4px solid #407aee;
  padding-left: 8px;
  margin: 16px;
}
.area-operator {
  display: block;
  width: 50px;
  margin-left: 10px;
  .el-icon-circle-plus-outline {
    font-size: 16px;
  }
  .el-button {
    // color: #fff !important;
  }
}
</style>
